import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import DefaultInput from "../../inputs/defaultInput";
import Loading from "../../skeleton/loading";
import DefaultTextarea from "../../inputs/defaultTextarea";
import DefaultButton from "../../buttons/defaultButton";
import {
    createDepartment,
    getDepartmentDetail,
    updateDepartment,
} from "../../../../services/workspace/department.service";
import { _updateDepartment } from "../../../../store/slices/baseSetup.slice";
import { _fetchDepartments } from "../../../../store/actions/configuration";
import { useDispatch } from "react-redux";

const validationSchema = Yup.object().shape({
    name: Yup.string().trim().required("Name is required"),
    abrv: Yup.string().trim().required("Abbreviation is required"),
    description: Yup.string().trim(),
});

const AddDepartmentForm = ({ isModal = false, closeModal = () => null }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { pathname } = useLocation();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState();
    const dispatch = useDispatch();

    useEffect(() => {
        if (id) {
            if (!pathname.includes("manage-departments")) return
            setLoading(true);
            getDepartmentDetail(id)
                .then((response) => {
                    setLoading(false);
                    setData(response);
                })
                .catch((error) => {
                    toast.error("Failed to fetch the department data!");
                });
        }
    }, [id, pathname]);

    const {
        handleSubmit,
        handleChange,
        handleBlur,
        setFieldValue,
        values,
        touched,
        errors,
    } = useFormik({
        initialValues: {
            name: data?.name || "",
            abrv: data?.abrv || "",
            description: data?.description || "",
        },
        validationSchema: validationSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            setIsSubmitting(true);
            const isModuleId = pathname.includes("manage-departments");
            if (id && isModuleId) {
                updateDepartment(values, id)
                    .then((response) => {
                        toast.success("Department updated successfully!");
                        navigate("/configuration/manage-departments");
                    })
                    .catch((error) => {
                        setIsSubmitting(false);
                        toast.error(
                            "Failed to update department!" + error.response.data?.message
                        );
                    });
            } else {
                createDepartment(values)
                    .then((response) => {
                        if (isModal) {
                            if (response) {
                                const payalod = { label: response?.name, value: response?.id, ...response }
                                dispatch(_updateDepartment(payalod))
                            } else {
                                dispatch(_fetchDepartments())
                            }
                            closeModal()
                        } else {
                            toast.success("Department created successfully!");
                            navigate("/configuration/manage-departments");
                        }
                    })
                    .catch((error) => {
                        setIsSubmitting(false);
                        toast.error(
                            "Failed to create department!" + error.response.data?.message
                        );
                    });
            }
        },
    });

    return (
        <>
            {loading ? (
                <Loading />
            ) : (
                <div className={`bg-white ${isModal ? "p-0" : "p-4"} flex flex-col gap-4`}>
                    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                        <div className={"grid grid-cols-2 gap-4 gap-y-2"}>
                            <DefaultInput
                                label={"Department Name"}
                                name="name"
                                value={values.name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.name && errors.name ? errors.name : ""}
                                required
                            />
                            <DefaultInput
                                label={"Abbreviation"}
                                name="abrv"
                                value={values.abrv}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.abrv && errors.abrv ? errors.abrv : ""}
                                required
                            />
                            <div className="col-span-2">
                                <DefaultTextarea
                                    label={"Description"}
                                    placeholder={"Write Description here..."}
                                    name="description"
                                    value={values.description}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={
                                        touched.description && errors.description
                                            ? errors.description
                                            : ""
                                    }
                                    
                                />
                            </div>
                        </div>
                        <div className="flex items-center gap-2">
                            <DefaultButton
                                variant="default"
                                name={"Submit"}
                                type="submit"
                                loading={isSubmitting}
                            />
                            {isModal ?
                                <DefaultButton
                                    variant="secondary"
                                    name={"Close"}
                                    onClick={closeModal}
                                /> : null}
                        </div>
                    </form>
                </div>
            )}
        </>
    )
}

export default AddDepartmentForm
